import React from 'react';
import { Box, Typography, Dialog, IconButton } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { makeStyles } from '@mui/styles';
import classes from './info.module.scss';
import CustomButton from '../UI/CustomButton';

const useStyles = makeStyles(() => ({
  paper: {
    borderRadius: '1rem',
    direction: 'rtl',
  },
}));

interface InfoDialogProps {
  openInfoDialog: boolean;
  closeDialog: () => void;
  message: string;
  title: string;
}

const InfoDialog: React.FC<InfoDialogProps> = (props) => {
  const { openInfoDialog, closeDialog, message, title } = props;
  const styles = useStyles();

  return (
    <Dialog
      onClose={closeDialog}
      open={openInfoDialog}
      maxWidth='lg'
      classes={{ paper: styles.paper }}
    >
      <Box className={classes.mainDialog}>
        <Box className={classes.header}>
          <Typography color='text.main' fontWeight='bold'>
            {title}
          </Typography>
          <IconButton onClick={closeDialog}>
            <CloseRoundedIcon color='action' />
          </IconButton>
        </Box>

        <Box mb={2} mt={1}>
          <Typography sx={{ whiteSpace: 'pre-line' }} color='text.light' fontSize='small'>
            {message}
          </Typography>
        </Box>

        <Box className={classes.footer}>
          <CustomButton fullWidth variant='contained' onClick={closeDialog}>
            بله، متوجه شدم
          </CustomButton>
        </Box>
      </Box>
    </Dialog>
  );
};

export default InfoDialog;
